import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { Play, RotateCcw, Sparkles, Sun, Moon, Sunrise } from 'lucide-react';
interface HeroSectionProps {
  userName: string;
  recommendation: {
    type: 'start' | 'continue' | 'review' | 'new';
    title: string;
    description: string;
    action: string;
    onClick: () => void;
  };
}
export function HeroSection({
  userName,
  recommendation
}: HeroSectionProps) {
  // Determine greeting based on time of day
  const hour = new Date().getHours();
  let greeting = 'Hallo';
  let Icon = Sun;
  if (hour < 12) {
    greeting = 'Goedemorgen';
    Icon = Sunrise;
  } else if (hour < 18) {
    greeting = 'Goedemiddag';
    Icon = Sun;
  } else {
    greeting = 'Goedenavond';
    Icon = Moon;
  }
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-indigo-600 to-indigo-500 text-white shadow-lg shadow-indigo-200/50" data-id="element-331">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-332">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-333">
          <circle cx="90" cy="10" r="40" fill="white" data-id="element-334" />
          <circle cx="10" cy="90" r="30" fill="white" data-id="element-335" />
        </svg>
      </div>

      <div className="relative z-10 p-6 flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-336">
        <div className="flex items-center gap-4" data-id="element-337">
          <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm hidden sm:block" data-id="element-338">
            <Icon className="w-6 h-6 text-white" data-id="element-339" />
          </div>
          <div data-id="element-340">
            <h1 className="text-2xl font-bold flex items-center gap-2" data-id="element-341">
              {greeting}, {userName}!{' '}
              <span className="animate-wave inline-block" data-id="element-342">👋</span>
            </h1>
            <p className="text-indigo-100 text-sm mt-1 opacity-90 max-w-lg" data-id="element-343">
              {recommendation.description}
            </p>
          </div>
        </div>

        <Button onClick={recommendation.onClick} size="md" className="bg-white text-indigo-600 hover:bg-indigo-50 border-none shadow-md hover:shadow-lg whitespace-nowrap min-w-[160px]" data-id="element-344">
          {recommendation.type === 'start' && <Play className="w-4 h-4 mr-2 fill-current" data-id="element-345" />}
          {recommendation.type === 'continue' && <Play className="w-4 h-4 mr-2 fill-current" data-id="element-346" />}
          {recommendation.type === 'review' && <RotateCcw className="w-4 h-4 mr-2" data-id="element-347" />}
          {recommendation.type === 'new' && <Sparkles className="w-4 h-4 mr-2" data-id="element-348" />}
          {recommendation.action}
        </Button>
      </div>
    </motion.div>;
}